var _circle, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeamManagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.50016,
    cy: 7.49998,
    r: 1.66667,
    stroke: "currentColor",
    strokeWidth: 1.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8332 12.5C10.8332 13.4205 10.8332 14.1666 7.49984 14.1666C4.1665 14.1666 4.1665 13.4205 4.1665 12.5C4.1665 11.5795 5.65889 10.8333 7.49984 10.8333C9.34079 10.8333 10.8332 11.5795 10.8332 12.5Z",
    stroke: "currentColor",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 9.99998C1.6665 6.85728 1.6665 5.28593 2.64281 4.30962C3.61913 3.33331 5.19047 3.33331 8.33317 3.33331H11.6665C14.8092 3.33331 16.3805 3.33331 17.3569 4.30962C18.3332 5.28593 18.3332 6.85728 18.3332 9.99998C18.3332 13.1427 18.3332 14.714 17.3569 15.6903C16.3805 16.6666 14.8092 16.6666 11.6665 16.6666H8.33317C5.19047 16.6666 3.61913 16.6666 2.64281 15.6903C1.6665 14.714 1.6665 13.1427 1.6665 9.99998Z",
    stroke: "currentColor",
    strokeWidth: 1.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8335 10H12.5002",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8335 7.5H11.6668",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8335 12.5H13.3335",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamManagement);
export default __webpack_public_path__ + "static/media/teamManagement.b817e582dda4f6b2368364b8342828c1.svg";
export { ForwardRef as ReactComponent };